export default {
    data() {
        return {
            showSuccess: false,
            allowSubmission: true,
        }
    },

    props: {
        submitTo: {
            required: true,
            type: String,
        },

        resetsOnSuccess: {
            default: false,
            type: Boolean
        }
    },

    methods: {
        send() {
            if (! this.allowSubmission || ! this.validate()) {
                return false;
            }

            this.allowSubmission = false;

            this.$http.post(this.submitTo, this.form).then(() => {
                if (this.resetsOnSuccess) {
                    this.resetForm();
                }

                this.showSuccess = true;

                _.delay(() => {
                    this.showSuccess = false;
                    this.allowSubmission = true;
                }, 3000);
            }).catch((error) => {
                _.each(error.response.data, (errors, key) => {
                    this.errors[key] = errors[0];
                });
                this.allowSubmission = true;
            });
        },

        validate() {
            let hasErrors = false;

            _.each(this.form, (field, key) => {
                if (field == '') {
                    this.errors[key] = 'The ' + key + ' field is required.'
                    hasErrors = true;
                }
            });

            return ! hasErrors;
        },

        clearErrors(target) {
            this.errors[target] = '';
        },

        resetForm() {
            _.each(this.form, (value, key) => {
                this.form[key] = '';
            })
        },
    },
}